import SessionTimeout from 'ui/session-timeout';

const SessionTimeoutTastic = () => {
  return <SessionTimeout />;
};

export default SessionTimeoutTastic;
